module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_7-ff5280aa12adb79aeb08fffdcccead03.jpg";